const AVATAR_PALETTE = [
  "#6366f1",
  "#7c3aed",
  "#0ea5e9",
  "#10b981",
  "#f59e0b",
  "#ec4899",
  "#8b5cf6",
  "#14b8a6",
] as const;

function hashString(value: string): number {
  let hash = 0;
  for (let i = 0; i < value.length; i += 1) {
    hash = (hash << 5) - hash + value.charCodeAt(i);
    hash |= 0;
  }
  return Math.abs(hash);
}

export function senderInitials(label: string): string {
  const cleaned = label.trim().replace(/["']/g, "");
  if (!cleaned) return "?";

  const parts = cleaned.split(/\s+/u).filter(Boolean);
  if (parts.length >= 2) {
    return `${parts[0][0] ?? ""}${parts[1][0] ?? ""}`.toUpperCase();
  }

  const word = parts[0] ?? cleaned;
  if (word.includes("@")) {
    return word.slice(0, 2).toUpperCase();
  }
  return word.slice(0, 2).toUpperCase();
}

export function senderAvatarColor(seed: string): string {
  const index = hashString(seed.toLowerCase()) % AVATAR_PALETTE.length;
  return AVATAR_PALETTE[index] ?? AVATAR_PALETTE[0];
}
